import React from "react";
import styled from "styled-components";
import { Device } from "../../../components/device";
import ImageCrop from "../UI/Image/ImageCrop";

//Usage:
/*
<PortraitQuote
    image="https://images.pexels.com/photos/2710131/pexels-photo-2710131.jpeg"
    author="Lance Armstrong">
    <p>"A boo is a lot louder than a cheer."</p>
</PortraitQuote>
*/

interface PortraitQuoteProps
{
    image?: string;
    author?: string;
    widerImage?: boolean;
}

const PortraitQuoteWrap = styled.div`
    display: flex;
`;

const PortraitQuoteImage = styled.div<PortraitQuoteProps>`
    width: 50%;
    ${Device.desktop} {
        width: ${props => (props.widerImage) ? "60%" : "50%"};
    }
`;

const PortraitQuoteAuthor = styled.div`
    position: relative;
    padding-left: 1.5rem;
    margin-top: .5rem;
    ${Device.laptop} {
        padding-left: 2rem;
    }
`;

const PortraitQuoteText = styled.blockquote<PortraitQuoteProps>`
    position: relative;
    font-family: var(--font-josefin-sans, 'Josefin Sans', sans-serif);
    width: 50%;
    ${Device.laptop} {
        width: ${props => (props.widerImage) ? "40%" : "50%"};
    }
`;

const PortraitQuoteInnerText = styled.div`
    padding: 1.5rem 0 0 1.5rem;
    font-size: var(--text-2xl, 1.5rem);
    line-height: var(--leading-tight, 1.25);
    margin-bottom: .5rem;
    font-weight: bold;
    letter-spacing: 0.035em;
    ${Device.tablet} {
        font-size: var(--text-3xl, 1.667rem);
    }
    ${Device.laptop} {
        font-size: var(--text-4xl, 2.333rem);
        padding-top: 2rem;
        padding-left: 2rem;
    }
`;

const PortraitQuoteCite = styled.cite`
    font-style: normal;
    text-transform: uppercase;
    text-align: left;
    margin-bottom: .5rem;
`;

const Dash = styled.span`
    display: inline-block;
    background-color: currentColor;
    height: 1px;
    position: absolute;
    top: 9px;
    width: 30px;
    left: 0;
    transform: translateX(-50%);
`;

const PortraitQuote: React.FunctionComponent<PortraitQuoteProps> = (props) =>
{
    return (
        <PortraitQuoteWrap className="mb-6 md:mb-0">
            <PortraitQuoteImage {...props}>
                {props.image ? <ImageCrop
                    src={props.image}
                    alt={props.author}
                    resizeMode={"crop"}
                    heightRatio={5/4} /> : null}
            </PortraitQuoteImage>
            <PortraitQuoteText {...props}>
                <PortraitQuoteAuthor>
                    <Dash />
                    <PortraitQuoteCite className="text-xSmall">{props.author}</PortraitQuoteCite>
                </PortraitQuoteAuthor>
                <PortraitQuoteInnerText>
                    {props.children}
                </PortraitQuoteInnerText>
            </PortraitQuoteText>
        </PortraitQuoteWrap>
    );
};

export default PortraitQuote;